import { IconBrandYoutube, IconPencil, IconTrash } from '@tabler/icons-react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import IconButton from '../../../../components/Buttons/IconButton';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import _debounce from 'lodash/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { disable, enable } from '../../../../redux/features/blockEdit/blockEditSlice';

const YoutubeDragBlock = React.memo(({ data, callback, dragButton }) => {

    const { pageId } = useParams();
    const [ytData, setYtData] = useState(null);

    const dispatch = useDispatch();
    const isEditable = useSelector((state) => state.isBlockEdit?.value);

    const editableName = 'youtube-block-' + data?._id

    const handleOnEditClick = () => {
        dispatch(enable(editableName))
    }

    async function updateStatus(status) {
        let url = `${urlApi.updateBlockStatus}${pageId}/${data?._id}/${status}`;
        loadingShow();
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            if (callback) {
                callback();
            }
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    const getYoutubeData = async (itemData) => {
        let regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        if (regex.test(document.getElementById('yt-url-' + itemData?._id)?.value?.trim())) {
            let postData = {
                "url": document.getElementById('yt-url-' + itemData?._id)?.value?.trim(),
            }
            let resp = await postApi(postData, urlApi.getYoutubeDataFromLink);
            setYtData(resp);
        } else {
            toast.error("Invalid YouTube URL")
        }
    }

    async function update(imageData) {
        loadingShow();
        let url = `${urlApi.updateBlockDetails}${pageId}/${data?._id}/${imageData?._id}`;
        let postData = {
            title: ytData?.data?.title || imageData?.title,
            destinationUrl: document.getElementById('yt-url-' + imageData?._id).value?.trim(),
            image: ytData?.data?.thumbnail || imageData?.image,
        }
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            if (callback) {
                callback();
            }
            dispatch(disable(''));
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }


    return (

        <div className='w-full'>
            <div className='flex gap-3 items-center w-full mb-2'>
                {isEditable != editableName && dragButton}
                <div className="flex gap-1 items-center">
                    <IconBrandYoutube size={16} />
                    <p className="mb-0 font-medium text-xs">Youtube</p>
                </div>
                {isEditable != editableName && <IconButton cssClass={'ms-auto'} icon={<IconPencil size={18} />} text={"Edit"} onClickFunction={() => handleOnEditClick()} />}
                {isEditable != editableName && <ConfirmationModal buttonComponent={<IconButton icon={<IconTrash size={18} />} />} confirmationText={"Are you sure want ro remove this block?"} onConfirm={() => updateStatus(3)} />}
            </div>

            <div className={`${isEditable == editableName ? 'ps-0' : 'ps-4'}`}>
                {isEditable == editableName ?
                    <div className='w-full'>
                        {
                            data?.images?.map((item, i) => {
                                return (
                                    <div key={i}>
                                        <div className='w-full mb-4'>
                                            <p className="text-md font-semibold mb-1.5">Youtube Video URL</p>
                                            <input type="text" className="form-control mb-2 w-full text-sm" id={'yt-url-' + item?._id} placeholder="ex. https://www.youtube.com/embed/id" onChange={_debounce((e) => getYoutubeData(item), 300)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        getYoutubeData(item);
                                                    }
                                                }} defaultValue={item?.destinationUrl} />
                                            {ytData?.responseCode == 500 && <p className='text-xs text-red-700'>{ytData?.message}</p>}
                                        </div>

                                        <div className="flex mt-3 items-center gap-4">
                                            <div className="bg-[#dbe0eb]">
                                                <img src={ytData?.data?.thumbnail ? ytData?.data?.thumbnail : item?.image ? item?.image : process.env.PUBLIC_URL + "/images/blocks/youtube.png"} alt="" className='h-28 rounded-md' />
                                            </div>
                                            <div>
                                                {(ytData?.data?.title || item?.title) && <p className="mb-0 text-md font-semibold text-[#686C8F]">Video Title</p>}
                                                <p className="mb-0 font-medium">{(ytData?.data?.title || item?.title) ?? "Add a YouTube URL above to preview the video"}</p>
                                            </div>
                                        </div>

                                        <div className="flex justify-end items-center mt-3 gap-3">
                                            <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => dispatch(disable(''))}>Cancel</button>
                                            <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => update(item)}>Update</button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <div className='w-full'>
                        {
                            data?.images?.map((item, i) => {
                                return (
                                    <div className="flex gap-3 mb-2 flex-wrap" key={i}>
                                        <img src={item?.image ? (item?.image) : process.env.PUBLIC_URL + "/images/image-upload.png"} alt="" className='h-20 rounded-md' />
                                        <div>
                                            <p className='mb-1 font-semibold'>{item?.title}</p>
                                            <p className="mb-0 text-xs text-[#686C8F]">{item?.destinationUrl}</p>
                                        </div>
                                    </div>)
                            })
                        }

                        <div className="flex justify-end">
                            <ToggleBtn state={data?.status == 1} onClickFunction={() => {
                                if (data?.status == 1) {
                                    updateStatus(2)
                                } if (data?.status == 2) {
                                    updateStatus(1)
                                }
                            }} />
                        </div>
                    </div>}
            </div>
        </div>
    )
})

export default YoutubeDragBlock